<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <div class="Info_Area">
      <b-card no-body>
        <b-tabs v-model="mainpage.tabnum" card>
          <b-tab
            v-show="mainpage.show"
            v-for="(item, index) in mainpage.tabobject"
            :key="index"
            :title="item.title"
          >
            <!-- <keep-alive> -->
            <component v-bind:is="item.component" :data="item.data"></component>
            <!-- </keep-alive> -->
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </b-container>
  <!-- <div>
    {{ type }}
  </div> -->
</template>

<script>
import Cropexpectation from "../components/Cropexpectation.vue";
import Cropmarketalaysis from "../components/Cropmarketalaysis.vue";
import CropmarketalaysisForMonth from "../components/CropmarketalaysisForMonth.vue";
import CropmarketalaysisForYear from "../components/CropmarketalaysisForYear.vue";
import Cropfiveyearstrade from "../components/Cropfiveyearstrade.vue";
import Fishcatchtradesearch from "../components/Fishcatchtradesearch.vue";
import Fishcatchcategorysummary from "../components/Fishcatchcategorysummary.vue";
import Fishcatchtotalquantity from "../components/Fishcatchtotalquantity.vue";
import Animaltrade from "../components/Animaltrade.vue";
import Animalvalues from "../components/Animalvalues.vue";
import Fowlsvalues from "../components/Fowlsvalues.vue";

export default {
  name: "NormalDashBoard",
  data() {
    return {
      breadcrumbItems: [],
      type: this.$route.params.type,
      mainpage: {
        tabnum: 0,
        show: false,
        tabobject: [],
        tabslist: [
          {
            title: "農情預測",
            component: Cropexpectation,
            data: { name: "農情預測" },
          },
          {
            title: "市場交易價量分析(日)",
            component: Cropmarketalaysis,
            data: { name: "市場交易價量分析(日)" },
          },
          {
            title: "市場交易價量分析(月)",
            component: CropmarketalaysisForMonth,
            data: { name: "市場交易價量分析(月)" },
          },
          {
            title: "市場交易價量分析(年)",
            component: CropmarketalaysisForYear,
            data: { name: "市場交易價量分析(年)" },
          },
          {
            title: "近五年交易量變化",
            component: Cropfiveyearstrade,
            data: { name: "近五年交易量變化" },
          },
          {
            title: "漁市場交易價量查詢",
            component: Fishcatchtradesearch,
            data: { name: "漁市場交易價量查詢" },
          },
          {
            title: "養殖魚種面積統計資料",
            component: Fishcatchcategorysummary,
            data: { name: "養殖魚種面積統計資料" },
          },
          {
            title: "漁業放養統計資料",
            component: Fishcatchtotalquantity,
            data: { name: "漁業放養統計資料" },
          },
          {
            title: "毛豬交易行情",
            component: Animaltrade,
            data: { name: "毛豬交易行情" },
          },
          {
            title: "家畜產值",
            component: Animalvalues,
            data: { name: "家畜產值" },
          },
          {
            title: "家禽產值",
            component: Fowlsvalues,
            data: { name: "家禽產值" },
          },
        ],
      },
    };
  },
  mounted() {
    if (this.type != null) {
      this.changeBread(this.type);
    }

    if (sessionStorage.getItem("Crop") != "") {
      this.mainpage.tabnum = 1;
    }
  },
  // created() {
  // },
  methods: {
    changeBread(value) {
      this.type = value;
      this.mainpage.show = false;
      this.mainpage.tabobject = [];
      this.mainpage.tabnum = 0;
      let obj = {
        text: "",
        active: false,
      };
      if (this.type == "crop") {
        obj.text = "農業資訊";
        this.mainpage.tabobject = this.mainpage.tabslist.slice(0, 5);
      } else if (this.type == "fishcatch") {
        obj.text = "漁業資訊";
        this.mainpage.tabobject = this.mainpage.tabslist.slice(5, 8);
      } else if (this.type == "animal") {
        obj.text = "畜產資訊";
        this.mainpage.tabobject = this.mainpage.tabslist.slice(8, 11);
      }

      this.breadcrumbItems = [
        {
          text: "首頁",
          href: "#/",
        },
      ];
      this.breadcrumbItems.push(obj);
      this.mainpage.show = true;
    },
  },
  watch: {
    "$route.params.type"(value) {
      this.changeBread(value);
    },
    // "mainpage.tabnum"(val) {
    // },
  },
};
</script>
